import { Box } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"

import { IS_JEWLR } from "helpers/application"

import ProductAddons from "./product-addons"
import SocialShare from "./social-share"
import WizardActions from "./wizard-actions"
import HeaderDesktop from "./wizard-header/header-desktop"
import WizardOptions from "./wizard-options"

const Container = styled(Box).attrs({
  bg: { _: "grey.4", tablet: "transparent" },
  p: { _: "18px 16px", tablet: "16px 0 0 " },
})``

const MainBody = ({ outOfStockRef }) => (
  <>
    <HeaderDesktop />
    <WizardOptions />
    <ProductAddons />
    <Container>
      <WizardActions outOfStockRef={outOfStockRef} />
      {IS_JEWLR() && <SocialShare />}
    </Container>
  </>
)

MainBody.propTypes = {
  outOfStockRef: PropTypes.object,
}

export default MainBody
